import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Button,
} from "@mui/material";
import { useUserRole } from "../api/GetData";
export const SidebarConfigPopup = ({ open, onClose, onSave }) => {
  const { data: userRole } = useUserRole();
  const role = (userRole || "").toLowerCase();
  const isOperator = role === "operator";
  const defaultSections = {
    ActualPrice: true,
    ForecastPrice: true,
    AilDemand: true,
    RenewablesBox: true,
    WisdmStatus: true,
    PowerplantStatus: true,
    Summary: true,
    AssetName:true,
    AssetIdentifier:true,
    AssetType:true,
    ActualCapacity: true,
    MinimumStableGeneration: true,
    MarginalCost: true,
    OfferControlParty: true,
    PowerAvailability: true,
    MinProfit: true,
    UnavailableHours: true,
    OptimizedRunLogic:true,
    McRunLogic:true,
    MinRunHours: true,
    DefaultLogic:true,
    MaxUnprofHours: true
  };

  const [sections, setSections] = useState(defaultSections);

  // Load saved preferences from localStorage on mount
  useEffect(() => {
    const saved = localStorage.getItem("sidebarSections");
    if (saved) {
      const parsed = JSON.parse(saved);
      const { Reason, ...rest } = parsed || {};
      setSections(rest);
    }
  }, []);

  const toggle = (key) => {
    if (isOperator && (key === "AilDemand" || key === "RenewablesBox")) {
      return;
    }
    setSections((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const handleSave = () => {
    const nextSections = isOperator
      ? { ...sections, AilDemand: false, RenewablesBox: false }
      : sections;
    localStorage.setItem("sidebarSections", JSON.stringify(nextSections));
    onSave(nextSections);
    onClose();
  };
  useEffect(() => {
    if (!isOperator) {
      return;
    }
    setSections((prev) => ({
      ...prev,
      AilDemand: false,
      RenewablesBox: false,
    }));
  }, [isOperator]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          backgroundColor: "#0b1422",
          color: "#e7edf7",
          border: "1px solid #22416b",
          borderRadius: "12px",
          boxShadow: "0 16px 36px rgba(10, 22, 42, 0.6)",
        },
      }}
    >
      <DialogTitle>Select Sidebar Sections</DialogTitle>
      <DialogContent dividers>
        <FormGroup>
          {Object.keys(sections)
            .filter((key) =>
              isOperator ? !["AilDemand", "RenewablesBox"].includes(key) : true
            )
            .map((key) => (
            <FormControlLabel
              key={key}
              control={
                <Checkbox
                  checked={sections[key]}
                  onChange={() => toggle(key)}
                  sx={{
                    color: "#e7edf7",
                    "&.Mui-checked": { color: "#1f6feb" },
                  }}
                />
              }
              label={key.replace(/([A-Z])/g, " $1")}
              sx={{ color: "#e7edf7" }}
            />
          ))}
        </FormGroup>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "space-between", px: 2, pb: 2 }}>
        <Button onClick={onClose} variant="outlined" sx={{ color: "#e7edf7", borderColor: "#22416b" }}>
          Cancel
        </Button>
        <Button variant="contained" color="primary" onClick={handleSave}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};
